import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ListStepsParams, Step, StepsService } from 'src/app/core/steps.service';
import { ERROR_STEP_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-steps-data',
  templateUrl: './steps-data.component.html',
  styleUrls: ['./steps-data.component.scss'],
})
export class StepsDataComponent {
  @ViewChild('steps_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  steps?: Step[];
  cursor: string | null = null;
  total?: number;
  filters?: ListStepsParams;

  constructor(private steps_service: StepsService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.steps = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listSteps();
  }

  onRefresh(): void {
    this.steps = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listSteps();
  }

  onFilter(filters?: ListStepsParams): void {
    this.steps = [];
    this.cursor = null;
    this.total = undefined;
    this.filters = filters;
    this.listSteps(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listSteps(this.filters, true);
  }

  listSteps(filters?: ListStepsParams, is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_steps_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.steps_service.listSteps(list_steps_params).subscribe({
      next: response => {
        const steps = response.data.data;
        this.steps = (this.steps ? this.steps : []).concat(steps);
        this.cursor = response.data.cursor;
        if (list_steps_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_STEP_NOT_FOUND) {
          this.steps = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
